import { SelectionDropdown } from "../../../../../../../components/Dropdown/SelectionDropdown.tsx";
import { useWorkspaceFonts } from "../../../../../../hooks/useWorkspaceFonts.ts";
import { SETTINGS_ITEM_WIDTH } from "../../constants.ts";

export const FontFamilySelectionDropdown = ({
  fontFamily,
  onFontFamilyChange,
}: {
  fontFamily: string;
  onFontFamilyChange: (value: string) => void;
}) => {
  const { workspaceFonts, builtinFonts } = useWorkspaceFonts();

  return (
    <SelectionDropdown
      value={fontFamily}
      onChange={onFontFamilyChange}
      options={[
        ...workspaceFonts.map((font) => ({
          value: font.family,
          label: font.family,
          style: { fontFamily: font.family },
        })),
        ...builtinFonts.map((font) => ({
          value: font.family,
          label: font.family,
          style: { fontFamily: font.family },
        })),
      ]}
      size="sm"
      buttonClassName={SETTINGS_ITEM_WIDTH}
      buttonStyle={{ fontFamily }}
    />
  );
};
